import cx from 'classnames';
import styles from './FooterCommonLink.module.scss';
import { ReactElement } from 'react';

interface FooterCommonLinkProps {
  label: string;
  isMobile?: boolean;
  iconLabel?: ReactElement;
  href?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const FooterCommonLink = ({
  label,
  iconLabel,
  isMobile,
  href,
  className = '',
  onClick,
  target = '_self'
}: FooterCommonLinkProps) => {
  return onClick ? (
    <>
      <button
        onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
        className={cx('d-none', 'd-md-block', styles['footer-common-link'])}
        aria-label={label}
      >
        {iconLabel ? iconLabel : label}
      </button>

      <button
        onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
        className={cx('d-md-none', styles['footer-common-link'], {
          [styles['footer-common-link-mobile']]: isMobile
        })}
        aria-label={label}
      >
        {iconLabel ? iconLabel : label}
      </button>
    </>
  ) : (
    <>
      <a
        rel="noopener noreferrer"
        href={href}
        target={target}
        className={cx('d-none', 'd-md-block', styles['footer-common-link'])}
        aria-label={label}
      >
        {iconLabel || label}
      </a>

      <a
        rel="noopener noreferrer"
        href={href}
        target={target}
        className={cx('d-md-none', styles['footer-common-link'], {
          [styles['footer-common-link-mobile']]: isMobile
        })}
        aria-label={label}
      >
        {iconLabel || label}
      </a>
    </>
  );
};
